<template>
    <div class="container">
        <div class="body">
            <div class="body-container f-s-b">
                <van-image 
                    class="body-image"
                    lazy-load
                    fit="contain"
                    :src="image"
                />
                <div class="body-title">预约成功</div>
                <div class="desc">请持身份证或电子二维码通过闸机入馆</div>
                <div class="body-desc">预约活动已经包含入馆门票，无需重复预约门票如需取消请提前1天取消，如预约后不参加将被纳入馆方黑名单，一年内不可再次预约任何活动</div>
                <div class="btn-box f-s-b">
                    <div class="f-c back-home" v-touch:tap="routerPage('ticketing')">返回首页</div>
                    <div class="f-c look-qr" v-touch:tap="lookQr">查看我的预约</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                image: require('@image/home/4567.png'),
                id: '',
            }
        },
        created() {
            let { id } = this.$route.query;
            this.id = id;
        },
        methods: {
            routerPage(name){
                return ()=> this.$router.push({ name })
            },
            lookQr(){
                //  查看二维码
                this.$router.push({ name: "QRCode", query: { id: this.id, tyep: 'signup' } })
                // this.$router.push({ name: "QRCode", query: { id: this.id } })
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";

    .container{
        .body{
            position: relative;
            box-sizing: border-box;
            height: 100%;
            min-height: 506px;
            padding: 20px 7px;
            .body-container{
                justify-content: flex-start;
                box-sizing: border-box;
                flex-direction: column;
                padding: 35px 30px 0;
                width: 100%;
                height:100%;
                background:rgba(255,255,255,1);
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                border-radius:5px;
                .body-image{
                    width: 200px;
                    height: 175px;
                }
                .body-title{
                    margin-top: 30px;
                    font-size:18px;
                    font-weight:600;
                    color: #365C84;
                }
                .desc{
                    // margin-top: 6px;
                    margin: 18px 0;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(71,75,78,1);
                }
                .body-desc{
                    // margin-top: 6px;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(98,98,98,1);
                }
                .btn-box{
                    margin-top: 74px;
                    width: 100%;
                    .back-home{
                        color: rgba(105,170,254,1);
                        width:135px;
                        height:37px;
                        border-radius:5px;
                        border:1px solid rgba(105,170,254,1);
                    }
                    .look-qr{
                        color: #ffffff;
                        width:135px;
                        height:37px;
                        background:rgba(92,162,253,1);
                        border-radius:5px;
                    }
                }
            }
        }
    }
</style>